import React, { createContext, useContext, useReducer } from 'react';

const AppContext = createContext();

const initialState = {
  cities: {}, // Now stores cities by country code
  hotels: {},
  hotelDetails: {},
  loading: false,
  error: null,
  searchCache: null // Cached search state for back-navigation persistence
};

function appReducer(state, action) {
  switch (action.type) {
    case 'SET_CITIES_BY_COUNTRY':
      return { 
        ...state, 
        cities: { 
          ...state.cities, 
          [`cities_${action.countryCode}`]: action.payload 
        }
      };
    case 'SET_HOTELS':
      return { 
        ...state, 
        hotels: { ...state.hotels, [action.cityCode]: action.payload }
      };
    case 'SET_HOTEL_DETAILS':
      return { 
        ...state, 
        hotelDetails: { ...state.hotelDetails, [action.hotelCode]: action.payload }
      };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    case 'SAVE_SEARCH_STATE':
      return { ...state, searchCache: action.payload };
    case 'CLEAR_SEARCH_STATE':
      return { ...state, searchCache: null };
    default:
      return state;
  }
}

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);
  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
}
